export default {
  methods: {
    userHasPremium() {
      return this.$store.state.profile.premium;
    },
  }
}
